
import { Vue, Options } from 'vue-class-component';
import CheckboxRound from './checkbox-round.vue'

@Options({
  components: {
    CheckboxRound
  },
  props: ['salon','salonSelected'],
  watch: {
    '$store.state.salon'(x){
      this.checked = x === this.salon
    }
  },
  data(){
    return{
      checked: this.$store.state.salon === this.salon
    }
  }
})

export default class SalonCard extends Vue {
}
